import React from 'react'
import './input.scss'

const Input = ({ textTooltip ='', label, name, id, type, placeholder, register, validationRules, error, maxLength, setValue, onChange, onBlurEvent, onFocusEvent, readOnly }) => {

    // Que le debe llegar a este componente?
    // --label: que sera el nombre arriba del campo mostrado on focus
    // --name: nombre com el que se identificara el input
    // --type: el tipo de input que es
    // --placeholder: este es autodescriptivo
    // --register: que viene del react hook form y lo enlaza el dato ingresado al formulario
    // --validationRules: estas son las validaciones que debe tener el input, justo con su mensaje de error
    // deben ser enviadas como un JSON
    // --error: aqui debe enviarse el error correspondiente al input y que contiene el mensaje de error

    const inputFocus = () => {
        let input = document.getElementById(name)
        let labelName = document.getElementById(name + label)

        input.classList.add("__focused")
        labelName.classList.add("__visible")
    }

    const inputFocusOut = () => {
        let input = document.getElementById(name)
        let labelName = document.getElementById(name + label)

        input.classList.remove("__focused")
        labelName.classList.remove("__visible")
    }

    return (
      <div className="f-a-input">
        <label id={name + label} htmlFor={name} className="f-a-input__label">
          {label}
        </label>
        <div id={name} className={"f-a-input__box " + (error ? "__error" : "")}>
          <input
            tabIndex="0"
            name={name}
            maxLength={maxLength}
            placeholder={placeholder}
            type={type}
            readOnly={readOnly}
            {...register(name, validationRules)}
            onChange={e => {
              if (e.target.value === " ") {
                setValue(name, "")
              } else {
                onChange(e)
                if (type === "number") {
                  let newValue = e.target.value.replace(/\D/g, "")
                  setValue(name, newValue)
                } else {
                  setValue(name, e.target.value.replace(/ {2}/g, " "))
                }
              }
            }}
            onFocus={() => {
              {
                onFocusEvent && onFocusEvent()
              }
              inputFocus()
            }}
            onBlur={() => {
              {
                onBlurEvent && onBlurEvent()
              }
              inputFocusOut()
            }}
            id={id ? id : "input" + name}
          />
        </div>
        {textTooltip && (
          <div class="f-a-input__tooltip left">
            <div class="f-a-input__icon-info">
              <span>i</span>
            </div>
            <span class="tiptext">{textTooltip}</span>
          </div>
        )}
        {error && <span className="f-a-input__error">{error.message}</span>}
      </div>
    )
}

// Especifica los valores por defecto de props:
Input.defaultProps = {
    onChange: () => { }
};

export default Input
